import { VehicleConfigurationRepository } from 'core/repositories/VehicleConfigurationRepository';
import { createDependency } from 'services/createDependency';

export const [useVehicleConfigurationRepository, withVehicleConfigurationRepository] = createDependency<VehicleConfigurationRepository>();
